import { Icon } from '@assembly-js/design-system';
import { SvgIconProps } from '@material-ui/core';

export const ContractIcon = (props: SvgIconProps) => (
  <Icon icon="Contract" {...props} />
);
